import React from 'react';
import { ScanLine } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-180">
          <div className="col-span-1 md:col-span-2" data-id="element-181">
            <Link to="/" className="flex items-center space-x-2 mb-4 group" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp" alt="IntelliEats icon" className="h-8 w-8 rounded-lg shadow-lg group-hover:shadow-brand-500/20 transition-all duration-300" data-id="element-183" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-184">
                Intelli<span className="text-brand-500" data-id="element-185">Eats</span>
              </span>
            </Link>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-186">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-187">
            <h3 className="text-white font-bold mb-4" data-id="element-188">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-189">
              <li data-id="element-190">
                <a href="/#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-191">
                  How It Works
                </a>
              </li>
              <li data-id="element-192">
                <a href="/#features" className="hover:text-brand-400 transition-colors" data-id="element-193">
                  Features
                </a>
              </li>
              <li data-id="element-194">
                <Link to="/blog" className="hover:text-brand-400 transition-colors" data-id="element-195">
                  Blog
                </Link>
              </li>
              <li data-id="element-196">
                <a href="/#download" className="hover:text-brand-400 transition-colors" data-id="element-197">
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-198">
            <h3 className="text-white font-bold mb-4" data-id="element-199">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-200">
              <li data-id="element-201">
                <Link to="/privacy" className="hover:text-brand-400 transition-colors" data-id="element-202">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/terms" className="hover:text-brand-400 transition-colors" data-id="element-204">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-205">
                <Link to="/contact" className="hover:text-brand-400 transition-colors" data-id="element-206">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-207">
          <p data-id="element-208">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-209">Developed by Nidhi Matele</p>
        </div>
      </div>
    </footer>;
}